// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2s-kY","select":"styles_select__2T67m"};